<template>
  <div class="py-4 mb-4">
    <div class="bg-blue-100 p-4 flex items-center justify-between">
      <div class="h-6 w-40 bg-blue-200 animate-pulse rounded"></div>
      <div class="h-10 w-10 bg-blue-200 animate-pulse rounded-full"></div>
    </div>

    <div class="space-y-6 mt-4">
      <div>
        <div class="h-4 w-20 bg-gray-200 animate-pulse rounded mb-3"></div>
        <div class="flex flex-wrap gap-4">
          <div class="h-4 w-16 bg-gray-200 animate-pulse rounded"></div>
          <div class="h-4 w-24 bg-gray-200 animate-pulse rounded"></div>
          <div class="h-4 w-28 bg-gray-200 animate-pulse rounded"></div>
          <div class="h-4 w-28 bg-gray-200 animate-pulse rounded"></div>
          <div class="h-4 w-20 bg-gray-200 animate-pulse rounded"></div>
          <div class="h-4 w-20 bg-gray-200 animate-pulse rounded"></div>
          <div class="h-4 w-32 bg-gray-200 animate-pulse rounded"></div>
        </div>
      </div>

      <div>
        <div class="h-4 w-16 bg-gray-200 animate-pulse rounded mb-3"></div>
        <div class="flex flex-wrap gap-4">
          <div class="h-4 w-28 bg-gray-200 animate-pulse rounded"></div>
          <div class="h-4 w-32 bg-gray-200 animate-pulse rounded"></div>
          <div class="h-4 w-36 bg-gray-200 animate-pulse rounded"></div>
        </div>
      </div>

      <div>
        <div class="h-4 w-16 bg-gray-200 animate-pulse rounded mb-3"></div>
        <div class="flex flex-wrap gap-4">
          <div class="h-4 w-40 bg-gray-200 animate-pulse rounded"></div>
          <div class="h-4 w-20 bg-gray-200 animate-pulse rounded"></div>
          <div class="h-4 w-28 bg-gray-200 animate-pulse rounded"></div>
          <div class="h-4 w-24 bg-gray-200 animate-pulse rounded"></div>
        </div>
      </div>
    </div>
  </div>
</template>
